import React from 'react';
import "./Carcard.styles.css"

interface CardProps {
  title: string;
  count: number;
  description: string;
  due?: string;
  titleColor?: string;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({ title, count, description, due, titleColor,onClick }) => {
  return (
    <div className="card card-one" style={{ borderLeft: `7px solid ${titleColor}`}}  onClick={onClick} >
      <div className="card-body overflow-hidden px-0">
        {title === "OBSERVATIONS" ? (
          <div className="card-content">
             <div className="card-subheading" style={{ color: titleColor, fontWeight:800 }}>{title}</div>
            <div className="d-flex">
              <div className="card-numbers">{count}</div>
              <span className="card-span">{description}</span>
            </div>
          </div>
        ) : (
          <div className="card-content">
             <div className="card-subheading" style={{ color: titleColor, fontWeight:800 }}>{title}</div>
            <div className="d-flex">
              <div className="card-numbers">{count}</div>
              <span className="card-span">{description}</span>
            </div>
            
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;
